module.exports = __webpack_public_path__ + "static/media/spell-detail.7e84a593.png";